module.exports = __webpack_public_path__ + "img/DSV.315a0a34.jpg";